export default __webpack_public_path__ + "static/media/rosbank.5d716e4a.png";